module.exports = __webpack_public_path__ + "img/kopf-kultur-2019.95da0c8e.svg";